var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pluginName),function(name){return _c('div',{key:name},[(_vm.hasComponent(name))?_c('div',[_c(name + _vm.type,_vm._b({tag:"component"},'component',_vm.$attrs,false))],1):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }